// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(min-width:768px){.span-2[data-v-0a999869]{grid-column:span 2}}.manage-section__tabs-wrapper[data-v-0a999869]{white-space:nowrap}@media(max-width:767px){.manage-section__tabs-wrapper[data-v-0a999869]{margin-left:-.9375rem;margin-right:-.9375rem;overflow-x:scroll;padding-bottom:.25rem;padding-left:.9375rem;padding-right:.9375rem}}@media(min-width:768px){.manage-section__tab-bar[data-v-0a999869]{justify-content:center}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
